export enum ScaStep {
  METHOD_SELECTION = 'METHOD_SELECTION',
  CODE_VERIFICATION = 'CODE_VERIFICATION',
  ERROR = 'ERROR'
}
